module.exports = __webpack_public_path__ + "media/newstyle/images/boleto-3b100c3a08c69718d2f5e66c9b044cf9.svg";